<template>
  <div class="check-list-delete auto-list_col_centered">
    <div>
      <el-button
        type="danger"
        icon="el-icon-delete"
        circle
        @click="openDialog"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Delete',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    onDeleteResponseClick: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    openDialog() {
      this.onDeleteResponseClick(this.response)
    },
  },
}
</script>

<style scoped></style>
